export default __webpack_public_path__ + "static/media/SamplePseudo.cbf31c08.png";